// extracted by mini-css-extract-plugin
export default {"button":"Global_button__mRGIT","buttonPrimary":"Global_buttonPrimary__w-40X","buttonAccented":"Global_buttonAccented__1gvJU","buttonIcon":"Global_buttonIcon__WCW+R"};